import { Link } from "react-router-dom"
import { SEO } from "@/components/SEO"
import { Card, CardContent } from "@/components/ui/card"
import { visibleDecks } from "@/config/decks"
import { FEATURES } from "@/config/features"
import { Presentation } from "lucide-react"

export function DeckListPage() {
  return (
    <>
      <SEO
        title="Pitch Decks"
        url="/decks"
        description={FEATURES.mining
          ? "Visual presentations explaining WELEPHANT Prediction Mining for players, miners, and investors."
          : "Visual presentations explaining the WELEPHANT token for holders, communities, and investors."}
      />
      <div className="container py-8 max-w-4xl mx-auto">
        <div className="mb-8">
          <div className="flex items-center gap-3 mb-2">
            <Presentation className="h-8 w-8 text-[hsl(var(--elephant))]" />
            <h1 className="text-3xl font-bold tracking-tight">Pitch Decks</h1>
          </div>
          <p className="text-muted-foreground">
            Shareable presentations to share with friends, communities, and investors. Click to present.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {visibleDecks.map((deck) => (
            <Link key={deck.slug} to={`/decks/${deck.slug}`} className="group">
              <Card className="overflow-hidden h-full hover:bg-muted/50 transition-colors">
                <CardContent className="p-6 text-center">
                  <img src={deck.icon} alt="" className="h-16 w-16 mx-auto mb-4" />
                  <h2 className="text-lg font-semibold mb-2 group-hover:text-[hsl(var(--elephant))] transition-colors">
                    {deck.title}
                  </h2>
                  <p className="text-muted-foreground text-sm mb-3">{deck.description}</p>
                  <div className="text-xs text-muted-foreground">
                    <span>{deck.audience}</span>
                    <span className="mx-2 text-border">|</span>
                    <span>~{deck.estimatedMinutes} min</span>
                  </div>
                </CardContent>
              </Card>
            </Link>
          ))}
        </div>
      </div>
    </>
  )
}
